import { requisitar } from '../api/cliente';
import { ordemServidor } from './formatacao';

export type Linha = Record<string, unknown> & { id: number; versao?: number };

/** Linhas por bloco da grade virtual (cursor). */
export const POR_BLOCO = 200;

interface Parametros {
  empresa: string | undefined;
  filial: string | undefined;
  alias: string;
  q: string;
  ordem: { campo: string; direcao: 'asc' | 'desc' }[];
}

/**
 * Consulta da lista de uma rotina. A página e o pré-carregamento (passar o mouse no menu) usam a mesma chave e a mesma busca:
 * quando a pessoa clica, o primeiro bloco já pode estar no cache.
 */
export function consultaLista({ empresa, filial, alias, q, ordem }: Parametros) {
  const o = ordemServidor(ordem);
  return {
    queryKey: ['dados', empresa, filial, alias, q, o] as const,
    initialPageParam: null as string | null,
    queryFn: async ({ pageParam, signal }: { pageParam: string | null; signal: AbortSignal }) => {
      const p = new URLSearchParams({ porPagina: String(POR_BLOCO) });
      if (q) p.set('q', q);
      if (o) p.set('o', o);
      if (pageParam) p.set('cursor', pageParam);
      const r = await requisitar<Linha[]>(`/tabelas/${alias}?${p}`, { sinal: signal });
      return { linhas: r.dados, total: Number(r.meta?.total ?? r.dados.length), estimado: Boolean(r.meta?.totalEstimado), proximo: (r.meta?.proximoCursor as string | null) ?? null };
    },
    getNextPageParam: (ultima: { proximo: string | null }) => ultima.proximo ?? undefined,
  };
}
